module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust1_m_en.31662ce799b8b15e77904d87ccf94e47.png";